// extracted by mini-css-extract-plugin
export default {"title":"RFjAw","caption":"yR7OG","caption-image":"NoEx5","captionImage":"NoEx5"};